import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en";
import de from "./locales/de";

export const SUPPORTED_LANGUAGES = ["en", "de"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// Detection order is deliberate:
//   1. querystring `?lang=de` — wins everywhere. QR codes printed in a
//      German plant can hardcode the language, no Browser-Accept-Language
//      guessing.
//   2. localStorage — sticky for repeat visits on the same device.
//   3. navigator — respects the browser preference for first-time visits.
// fallbackLng = en keeps the portal usable for any locale that isn't
// explicitly supported.
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en, de },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: "common",
    ns: ["common", "lookup", "product", "errors"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "hwidalloc-customer.lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
